export default __webpack_public_path__ + "static/media/CAP3V-thumbnail-cc.1f18b097.png";